import React, { useEffect, useState } from "react";
import { api } from "../../lib/api.js";
import { fmtDateTime } from "../../lib/format.js";
import { Shield } from "lucide-react";

export function OverridesTab() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    api.get("/audit-log?action=Override used&limit=300").then((r) => setEntries(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="overrides-tab">
      <div className="bg-white border border-gray-200 rounded-md p-3 mb-3">
        <h2 className="font-heading text-base font-bold text-[#1A1A2E] flex items-center gap-2">
          <Shield className="w-4 h-4 text-[#1F3864]" /> Overrides de gestores
        </h2>
        <p className="text-xs text-[#6C757D] mt-0.5">
          Cada override (ex: Pedido de Peças marcado como Encomendado sem ordem de cliente Alidata, consumo MPM fora de sequência) fica registado aqui com o gestor que aprovou, justificação e data/hora.
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F6F8] text-[10px] uppercase tracking-wider text-[#6C757D]">
            <tr>
              <th className="px-3 py-2 text-left">Quando</th>
              <th className="px-3 py-2 text-left">Aprovador</th>
              <th className="px-3 py-2 text-left">Perfil</th>
              <th className="px-3 py-2 text-left">Registo</th>
              <th className="px-3 py-2 text-left">Justificação / Motivo</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="5" className="px-3 py-4 text-center text-xs text-[#6C757D]">A carregar…</td></tr>}
            {!loading && entries.length === 0 && <tr><td colSpan="5" className="px-3 py-4 text-center text-xs text-[#6C757D]">Ainda não há overrides registados.</td></tr>}
            {entries.map((e) => (
              <tr key={e.id} className="border-t border-gray-100" data-testid={`override-row-${e.id}`}>
                <td className="px-3 py-2 text-xs whitespace-nowrap">{fmtDateTime(e.timestamp)}</td>
                <td className="px-3 py-2 text-xs">{e.user_name}</td>
                <td className="px-3 py-2 text-xs text-[#6C757D]">{(e.user_role || "").replaceAll("_", " ")}</td>
                <td className="px-3 py-2 text-xs font-mono">{e.record_type} · {e.record_id?.slice(0, 8)}</td>
                <td className="px-3 py-2 text-xs">{e.comment}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


